<template>
  <div class="bg-gray-100 pt-8">
      <div class="flex justify-between px-6 lg:px-20 py-8 w-full">
          <h2 class="text-xl lg:text-2xl font-semibold"> रोजगारी मुलक जानकारी</h2>
          <h2 class="text-lg">सबै हेर्नुहोस् </h2>
      </div>
      <div class="px-12 lg:px-20 lg:flex lg:space-x-8">
          <div class="overflow-hidden w-72 pb-8 shadow-sm hover:shadow-xl cursor-pointer filter-none hover:filter-grayscale transition ease-out duration-500">
              <img src="../assets/img/blog.jpg">
              <h3 class="text-sm text-gray-400 text-center mt-2 z-10">Event <span class="pl-4"></span> 28 jul 2020</h3>
              <h2 class="truncate text-xl text-blue-800 mt-2">एच.आर. ह्यापपि हावर 2020 नेपालगंजमा सम्पन्न </h2>
          </div>
          <div class="overflow-hidden w-72 pb-8 shadow-sm hover:shadow-xl cursor-pointer filter-none hover:filter-grayscale transition ease-out duration-500">
              <img src="../assets/img/blog.jpg">
              <h3 class="text-sm text-gray-400 text-center mt-2 z-10">Event <span class="pl-4"></span> 28 jul 2020</h3>
              <h2 class="truncate text-xl text-blue-800 mt-2">एच.आर. ह्यापपि हावर 2020 नेपालगंजमा सम्पन्न </h2>
          </div>
          <div class="overflow-hidden w-72 pb-8 shadow-sm hover:shadow-xl cursor-pointer filter-none hover:filter-grayscale transition ease-out duration-500">
              <img src="../assets/img/blog.jpg">
              <h3 class="text-sm text-gray-400 text-center mt-2 z-10">Event <span class="pl-4"></span> 28 jul 2020</h3>
              <h2 class="truncate text-xl text-blue-800 mt-2">एच.आर. ह्यापपि हावर 2020 नेपालगंजमा सम्पन्न </h2>
          </div>
          <div class="overflow-hidden w-72 pb-8 shadow-sm hover:shadow-xl cursor-pointer filter-none hover:filter-grayscale transition ease-out duration-500">
              <img src="../assets/img/blog.jpg">
              <h3 class="text-sm text-gray-400 text-center mt-2 z-10">Event <span class="pl-4"></span> 28 jul 2020</h3>
              <h2 class="truncate text-xl text-blue-800 mt-2">एच.आर. ह्यापपि हावर 2020 नेपालगंजमा सम्पन्न </h2>
          </div>
      </div>
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>